import { createContext, FunctionComponent } from 'preact';
import { useContext, useMemo } from 'preact/hooks';

import { SchibstedAccount } from '../config';

const SchibstedAccountContext = createContext<SchibstedAccount>(null!);

export interface SchibstedAccountProviderProps {
  schibstedAccount: SchibstedAccount;
}

export const SchibstedAccountProvider: FunctionComponent<
  SchibstedAccountProviderProps
> = ({ schibstedAccount, children }) => {
  const state = useMemo(() => ({ ...schibstedAccount }), [schibstedAccount]);

  return (
    <SchibstedAccountContext.Provider value={state}>
      {children}
    </SchibstedAccountContext.Provider>
  );
};

export const useSchibstedAccount = () => {
  const schibstedAccount = useContext(SchibstedAccountContext);

  if (process.env.NODE_ENV !== 'production' && !schibstedAccount) {
    console.warn(
      'Schibsted Account context is undefined, please verify you are calling useSchibstedAccount() as child of a <SchibstedAccountProvider> component.'
    );
  }

  return schibstedAccount;
};
